import React, {useRef, useState, useEffect, useMemo  } from "react";
import { useLocation, Link, useParams } from "react-router-dom";
import { FaFileContract, FaFileSignature, FaUserPlus, FaHandshake, FaInfoCircle } from "react-icons/fa";
import { MdEmail, MdLock, MdPerson } from "react-icons/md";
import Layout from "../../Layout/Layout";
import {activatorUserAdding, userAssUpRoleTrueRandom, isAuthenticated, getElakayLang,} from "../../auth";
import AddinfoUser from "./addinforUser";
import AddtelephoneUserAssociate from "./addTelephoneUser";
import AddAddressUserAssociate from "./addAdressUser";
import GetEditInfoUser from "./getEditInfoUser";
import {laguangeElakay} from "../../pageInside/dataElakay";
import Modal from 'react-bootstrap/Modal';
import ActivationCountdown from "../../pageInside/ActivationCountdown";
import ActivatorPageAss from "../addUserPage/activatorPageAss";
import { elakayAutoText } from "../../pageInside/dataElakay";
import { resolveUserAddingRoleToken, persistUserAddingRoleTokenIfNeeded, buildUserAddingRoleTokenPath, RETURN_URL_QUERY_PARAM } from "../../../utils/userAddingRoleToken";
import RoleDocumentContent from "../../pageInside/roleDocuments/RoleDocumentContent";
import useRoleDocuments from "../../pageInside/roleDocuments/useRoleDocuments";
import {
    DOCUMENT_STATUS,
    canonicalRoleId,
    getReadableRoleIds,
    getRoleDocumentKeys,
    resolveViewedRole,
    roleDocumentsText,
} from "../../../utils/roleDocuments";
import "./userAddingRoleByToken.css";
import "../../pageInside/roleDocuments/roleDocuments.css";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["userAddingRoleByToken"]?.[key] || fallback;

// import Active from "../../user/active";

function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

 const incompleteProfileAlert = {
    "fr": {
      "title": __elakayText("t001", "Informations incomplètes"),
      "body": "Veuillez ajouter les informations manquantes (comme votre nom, prénom, email, mot de passe, téléphone et votre adresse) pour que cette case soit automatiquement cochée.",
      "link": "Cliquez ici pour compléter votre profil"
    },
    "en": {
      "title": __elakayText("t002", "Incomplete information"),
      "body": "Please add the missing information (such as your name, first name, email, password, phone number, and your address) so this checkbox can be automatically checked.",
      "link": "Click here to complete your profile"
    },
    "ht": {
      "title": __elakayText("t003", "Enfòmasyon enkonplè"),
      "body": "Tanpri ajoute tout enfòmasyon ki manke (tankou non, siyati, imel, modpas, nimewo telefòn ak adrès ou) pou ti kare sa a make otomatikman.",
      "link": "Klike la pou konplete pwofil ou"
    },
    "es": {
      "title": __elakayText("t004", "Información incompleta"),
      "body": "Por favor, agregue la información que falta (como su nombre, apellido, correo electrónico, contraseña, número de teléfono y dirección) para que esta casilla se marque automáticamente.",
      "link": "Haga clic aquí para completar su perfil"
    },
    "pt": {
      "title": __elakayText("t005", "Informações incompletas"),
      "body": "Por favor, adicione as informações ausentes (como seu nome, sobrenome, e-mail, senha, telefone e endereço) para que esta caixa seja marcada automaticamente.",
      "link": "Clique aqui para completar seu perfil"
    }
  }
 export const welcomeMessages = {
  "royalty": {
    "en": {
      "accountTitle": "Your account is active",
      "headline": "Welcome {name}!",
      "subheading": "As a Royalty member of Elakay",
      "body": "You are part of an elite experience. With exclusive access and privileges, your journey on Elakay will be rewarding and inspiring every step of the way."
    },
    "fr": {
      "accountTitle": "Votre compte est actif",
      "headline": "Bienvenue {name} !",
      "subheading": "En tant que membre Royalty d’Elakay",
      "body": "Vous faites partie d'une expérience unique. Avec des privilèges exclusifs, votre parcours sur Elakay sera enrichissant et mémorable."
    },
    "ht": {
      "accountTitle": "Kont ou aktif",
      "headline": "Byenveni {name} !",
      "subheading": "Kòm manm Royalty Elakay",
      "body": "Ou fè pati eksperyans elit la. Avèk aksè espesyal ak privilèj, w ap jwi chak etap sou Elakay ak fyète."
    },
    "es": {
      "accountTitle": "Su cuenta está activa",
      "headline": "¡Bienvenido {name}!",
      "subheading": "Como miembro Royalty de Elakay",
      "body": "Usted forma parte de una experiencia exclusiva. Con privilegios especiales, su camino en Elakay será único y enriquecedor."
    },
    "pt": {
      "accountTitle": "Sua conta está ativa",
      "headline": "Bem-vindo {name}!",
      "subheading": "Como membro Royalty do Elakay",
      "body": "Você faz parte de uma experiência de elite. Com acessos exclusivos, sua jornada será valiosa e inesquecível."
    }
  },
  "seller": {
    "en": {
      "accountTitle": "Your account is active",
      "headline": "Welcome {name}!",
      "subheading": "As a Seller on Elakay",
      "body": "Your products bring life to Elakay's marketplace. Through your creativity and passion, you support economic growth and empower a thriving community."
    },
    "fr": {
      "accountTitle": "Votre compte est actif",
      "headline": "Bienvenue {name} !",
      "subheading": "En tant que vendeur sur Elakay",
      "body": "Vos produits donnent vie à notre marketplace. Grâce à votre créativité et votre énergie, vous soutenez l'économie locale et la croissance partagée."
    },
    "ht": {
      "accountTitle": "Kont ou aktif",
      "headline": "Byenveni {name} !",
      "subheading": "Kòm vandè sou Elakay",
      "body": "Pwodui ou pote lavi nan platfòm lan. Ak pasyon ak kreyativite ou, ou sipòte devlopman ekonomik kominote a."
    },
    "es": {
      "accountTitle": "Su cuenta está activa",
      "headline": "¡Bienvenido {name}!",
      "subheading": "Como vendedor en Elakay",
      "body": "Sus productos animan el mercado de Elakay. Con su creatividad, usted impulsa la economía y fortalece la comunidad."
    },
    "pt": {
      "accountTitle": "Sua conta está ativa",
      "headline": "Bem-vindo {name}!",
      "subheading": "Como vendedor no Elakay",
      "body": "Seus produtos dão vida ao mercado Elakay. Com criatividade e dedicação, você impulsiona o crescimento econômico local."
    }
  },
  "provider": {
    "en": {
      "accountTitle": "Your account is active",
      "headline": "Welcome {name}!",
      "subheading": "As a Provider on Elakay",
      "body": "Your services are essential to the success of others. You offer reliability and excellence that keep Elakay running efficiently and professionally."
    },
    "fr": {
      "accountTitle": "Votre compte est actif",
      "headline": "Bienvenue {name} !",
      "subheading": "En tant que provider sur Elakay",
      "body": "Vos services sont essentiels au succès collectif. Votre fiabilité et professionnalisme assurent une plateforme efficace et fluide."
    },
    "ht": {
      "accountTitle": "Kont ou aktif",
      "headline": "Byenveni {name} !",
      "subheading": "Kòm provider sou Elakay",
      "body": "Sèvis ou enpòtan anpil pou siksè lòt yo. Ou pote efikasite ak kalite nan tout sa w ap fè sou platfòm lan."
    },
    "es": {
      "accountTitle": "Su cuenta está activa",
      "headline": "¡Bienvenido {name}!",
      "subheading": "Como proveedor en Elakay",
      "body": "Sus servicios son fundamentales para el éxito de todos. Su excelencia mantiene la plataforma activa y eficaz."
    },
    "pt": {
      "accountTitle": "Sua conta está ativa",
      "headline": "Bem-vindo {name}!",
      "subheading": "Como fornecedor no Elakay",
      "body": "Seus serviços são cruciais para o sucesso coletivo. Com excelência e confiança, você mantém a plataforma funcionando bem."
    }
  },
  "associate": {
    "en": {
      "accountTitle": "Your account is active",
      "headline": "Welcome {name}!",
      "subheading": "As an Associate on Elakay",
      "body": "You play a key role in growing and managing the network. You support users and ensure the platform thrives with balance and structure."
    },
    "fr": {
      "accountTitle": "Votre compte est actif",
      "headline": "Bienvenue {name} !",
      "subheading": "En tant qu’associate sur Elakay",
      "body": "Vous jouez un rôle essentiel dans la croissance du réseau. Vous encadrez les utilisateurs et assurez l’équilibre de la plateforme."
    },
    "ht": {
      "accountTitle": "Kont ou aktif",
      "headline": "Byenveni {name} !",
      "subheading": "Kòm associate sou Elakay",
      "body": "Wòl ou se jere ak ede kominote a grandi. Ou sipòte itilizatè yo epi ou kenbe balans ak estrikti sou platfòm lan."
    },
    "es": {
      "accountTitle": "Su cuenta está activa",
      "headline": "¡Bienvenido {name}!",
      "subheading": "Como associate en Elakay",
      "body": "Usted guía el crecimiento de nuestra comunidad. Su trabajo garantiza orden, apoyo y evolución dentro de la red."
    },
    "pt": {
      "accountTitle": "Sua conta está ativa",
      "headline": "Bem-vindo {name}!",
      "subheading": "Como associate no Elakay",
      "body": "Você contribui para o crescimento e equilíbrio da rede. Seu papel é apoiar e organizar a comunidade Elakay com excelência."
    }
  },
  "investment": {
    "en": {
      "accountTitle": "Your account is active",
      "headline": "Welcome {name}!",
      "subheading": "As an Investor of Elakay",
      "body": "Your commitment brings innovation and opportunity. You are helping build a sustainable future for digital commerce and local impact."
    },
    "fr": {
      "accountTitle": "Votre compte est actif",
      "headline": "Bienvenue {name} !",
      "subheading": "En tant qu’investisseur Elakay",
      "body": "Votre engagement stimule l’innovation et l’emploi. Vous bâtissez un avenir durable et humain pour le commerce numérique."
    },
    "ht": {
      "accountTitle": "Kont ou aktif",
      "headline": "Byenveni {name} !",
      "subheading": "Kòm envestisè sou Elakay",
      "body": "Angajman ou kreye opòtinite. Ou ap ede konstwi yon avni solid pou komès dijital ak devlopman lokal."
    },
    "es": {
      "accountTitle": "Su cuenta está activa",
      "headline": "¡Bienvenido {name}!",
      "subheading": "Como inversor en Elakay",
      "body": "Su compromiso impulsa el crecimiento sostenible. Usted apoya un futuro próspero para toda la red de comercio digital."
    },
    "pt": {
      "accountTitle": "Sua conta está ativa",
      "headline": "Bem-vindo {name}!",
      "subheading": "Como investidor no Elakay",
      "body": "Seu compromisso gera inovação e impacto local. Juntos, construímos um futuro econômico mais justo e sustentável."
    }
  },
  "administrator": {
    "en": {
      "accountTitle": "Your account is active",
      "headline": "Welcome {name}!",
      "subheading": "As an Administrator of Elakay",
      "body": "You are a leader and a visionary. Your decisions shape the future of the platform, and your guidance strengthens the entire ecosystem."
    },
    "fr": {
      "accountTitle": "Votre compte est actif",
      "headline": "Bienvenue {name} !",
      "subheading": "En tant qu’administrateur Elakay",
      "body": "Vous êtes un leader engagé. Vos décisions façonnent l’avenir de la plateforme et renforcent tout l’écosystème Elakay."
    },
    "ht": {
      "accountTitle": "Kont ou aktif",
      "headline": "Byenveni {name} !",
      "subheading": "Kòm administratè sou Elakay",
      "body": "Ou se yon lidè ak vizyonè. Ou gide direksyon platfòm lan e ou mete estabilite nan tout sistèm lan."
    },
    "es": {
      "accountTitle": "Su cuenta está activa",
      "headline": "¡Bienvenido {name}!",
      "subheading": "Como administrador de Elakay",
      "body": "Su liderazgo guía el rumbo de nuestra comunidad. Sus decisiones impactan cada rincón del ecosistema Elakay."
    },
    "pt": {
      "accountTitle": "Sua conta está ativa",
      "headline": "Bem-vindo {name}!",
      "subheading": "Como administrador do Elakay",
      "body": "Você é responsável por liderar e fortalecer nossa rede. Suas escolhas constroem o caminho do Elakay para o futuro."
    }
  },

  family: {
    en: {
      accountTitle: "Your account is active",
      headline: "Welcome {name}!",
      subheading: "As an Elakay Developer",
      body: "Your presence in our community reflects trust and long-term connection. You are part of our foundation, and together we build a culture of unity, love, and collective growth."
    },
    fr: {
      accountTitle: "Votre compte est actif",
      headline: "Bienvenue {name} !",
      subheading: "En tant que Développeur Elakay",
      body: "Votre présence renforce les liens humains. Ensemble, nous créons une culture de partage, de confiance et d’unité durable dans notre écosystème."
    },
    ht: {
      accountTitle: "Kont ou aktif",
      headline: "Byenveni {name} !",
      subheading: "Kòm manm fanmi Elakay",
      body: "Ou se poto mitan fanmi an. Ansanm n ap bati yon kominote ki baze sou lanmou, solidarite, ak kwasans kolektif."
    },
    es: {
      accountTitle: "Su cuenta está activa",
      headline: "¡Bienvenido {name}!",
      subheading: "Como parte de la familia Elakay",
      body: "Su conexión con nosotros es profunda. Juntos fortalecemos una comunidad basada en el respeto, la unidad y el crecimiento colectivo."
    },
    pt: {
      accountTitle: "Sua conta está ativa",
      headline: "Bem-vindo {name}!",
      subheading: "Como membro da família Elakay",
      body: "Você faz parte da nossa base afetiva. Construímos juntos uma cultura de união, confiança e prosperidade para todos."
    }
  }
};

const WelcomeAlertShow = ({ roleName, userName, codeLang, messageWelcome, setMessageWelcome }) => {
  const roleKey = roleName.toLowerCase();
  const lang = welcomeMessages[roleKey]?.[codeLang] ? codeLang : "en";
  const msg = welcomeMessages[roleKey]?.[lang];

  if (!msg) return null;

  const replaceName = (text) => text.replace("{name}", userName);

  return (
    <div className="container">
      <div className="row justify-content-center">
        <Modal
          show={messageWelcome}
          onHide={() => setMessageWelcome(false)}
          contentClassName="uart-modal-content"
          centered
        >
          <Modal.Header closeButton className="uart-modal-header uart-modal-header-welcome">
            <Modal.Title>
              <h2 className="text-center">{msg.accountTitle}</h2>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="uart-modal-body uart-modal-body-welcome">
            <div>
              <h2>{replaceName(msg.headline)}</h2>
              <h4 className="text-center">{msg.subheading}</h4>
              <p>{msg.body}</p>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

const  UserAddingRoleByToken = (props) => {

    const {
        infoSource
        } = props
            __setElakayInfoSource(infoSource);

             const location = useLocation(); // Surveille les changements d'URL
              const query = useQuery();
              // "?r=<Role>": a role to read first -- only ever applied when the
              // backend says it's readable for this invitation.
              const requestedFromUrl = query.get("r");
            const autheToken = isAuthenticated()? isAuthenticated().token : null;
            const {obj} = getElakayLang();
            const {code }= obj
        let params = useParams();
        const urlToken = params.token;
        // Single source of truth for the active token: URL param takes priority,
        // localStorage["token_userAdding"] is the fallback, never "undefined"/"null"/"".
        let token = useMemo(() => resolveUserAddingRoleToken(urlToken), [urlToken]);
    const [loading, setLoading] = useState(false);
    // "resolving" until we've had a chance to persist a fresh URL token; then
    // "ready" (a usable token exists) or "error" (nothing usable was found).
    const [tokenStatus, setTokenStatus] = useState(token ? "ready" : "resolving");
     // Token of the invitation currently displayed: responses for any other
     // (older) token are ignored.
     const activeTokenRef = useRef(token);
     // "?r=" already applied for this token + search string.
     const appliedSearchRef = useRef(null);
    const [roleUser,  SetRoleUser] = useState('Royalty')
    const [userLeve, getUserleve] = useState()
    const [activePageAss, setActivePageAss] = useState(false)
    const [messageWelcome, setMessageWelcome] = useState(false)
    const [messageExp, setMessageExp] = useState(false);
    // Distinguishes *why* the link isn't usable (INVALID_TOKEN / TOKEN_EXPIRED
    // / TOKEN_NOT_FOUND, from authAddingUser.js via activatorUserAdding's
    // err.code) so expireLink() can show a precise message instead of one
    // generic "expired" title regardless of the real cause.
    const [activationErrorCode, setActivationErrorCode] = useState(null);
    const [userInfo, setUserInfo] = useState({});
    const [planAfCh, setPlanAfCh] = useState(false);
    const [ternConCh, setTernConCh] = useState(false);
    const [agreUsIn, setAgreUsIn] = useState(false);
    const [agreeCh, setAgreeCh] = useState(false);
    const [roleNamePage, setRoleNamePage] = useState({
        plan: '',
        term:'',
        agree:'',
        role:''
    });

    let userRolle = [
        {name: "Royalty", label: __elakayText("t006", "Royalty"), leve: 1},
        {name: "Seller", label: __elakayText("t007", "Seller"), leve: 2},
        {name: "Provider", label: __elakayText("t008", "Provider"), leve: 3},
        {name: "Associate", label: __elakayText("t009", "Associate"), leve: 4},
        {name: "Investment", label: __elakayText("t010", "Investment"), leve: 5},
        {name: "Administrator", label: __elakayText("t011", "Administrator"), leve: 6},
        {name: "Family", label: __elakayText("t012", "Developer"), leve: 7}]

    const roleLevelByName = (name) => userRolle.find((r) => r.name === name)?.leve || 0;

    // The account's real "how far down the hierarchy can this user browse"
    // ceiling -- never just assignedRole.level (this invitation's own role)
    // and never just userActiveRole.level alone (the account's current
    // *top* managed role, e.g. Associate/Administrator/Family). A user can
    // already hold several independently-grantable roles at once: the
    // self-service ones (Royalty/Seller/Provider) persist as boolean flags
    // on userActiveRole (see server_elakay/elakay_services/roleActivation.js
    // ROLE_CONFIG's customer/seller/provider flags) even after a *different*
    // role becomes the current top-level one, so the real ceiling is the
    // highest level found across all of them.
    const computeMaxAuthorizedLevel = (userActiveRole, assignedRole) => {
        const candidates = [
            roleLevelByName(userActiveRole?.roleName),
            roleLevelByName(assignedRole?.roleName),
            userActiveRole?.customer ? roleLevelByName('Royalty') : 0,
            userActiveRole?.seller ? roleLevelByName('Seller') : 0,
            userActiveRole?.provider ? roleLevelByName('Provider') : 0,
            Number.isFinite(userActiveRole?.level) ? userActiveRole.level : 0,
            Number.isFinite(assignedRole?.level) ? assignedRole.level : 0,
        ];
        return Math.max(0, ...candidates);
    };

const { role } = roleNamePage

    // Read access + documents of the viewed role, always with THIS page's
    // token (URL first), never another one saved in localStorage.
    const roleDocs = useRoleDocuments({
        invitationToken: token,
        authToken: autheToken,
        lang: code,
        viewedRole: role || null,
        enabled: tokenStatus === "ready" && Boolean(token),
    })
    const rd = (key, fallback, values) => roleDocumentsText(infoSource, key, fallback, values)
    // Roles offered in the picker: what the backend allows for this
    // invitation, never above the invitation/current role ceiling.
    const readableRoleIds = getReadableRoleIds(
        roleDocs.accessStatus === DOCUMENT_STATUS.SUCCESS ? roleDocs.access : null,
        userLeve || 0
    ).filter((roleId) => roleLevelByName(roleId) <= (userLeve || 0))

    let BnPlanAffaire = {
        planAffaire : true,
        termCondition: false,
        addInfoUser: false,
        userAgree: false
    }
    let bnTermCondition ={
    planAffaire : false,
    termCondition: true,
    addInfoUser: false,
    userAgree: false
    }
    let bnAddInfoUser={
    planAffaire : false,
    termCondition: false,
    addInfoUser: true,
    userAgree: false
    }

    let bnUserAgree ={
    planAffaire : false,
    termCondition: false,
    addInfoUser: false,
    userAgree: true
    }

    const [pages, setPages]= useState(BnPlanAffaire)

    const {
        planAffaire,
        termCondition,
        addInfoUser,
        userAgree,
        } = pages

        let bninfoPersonnel ={
            infoPersonnel: true,
            telephone: false,
            AddAdress:false
        }

        let bnTelephone = {
            infoPersonnel: false,
            telephone: true,
            AddAdress:false
            }

        let bnAddAdress ={
            infoPersonnel: false,
            telephone: false,
            AddAdress:true
            }

        const [pagesUser, setPagesUser]= useState(bninfoPersonnel)

        const { 
            infoPersonnel,
            telephone,
            AddAdress  
        } = pagesUser

          const divInfoRoll = useRef(null);
          const pendingContentScroll = useRef(false);
        
        const scrollToParagraph = (ref) => {
                 if (ref && ref.current) {
    ref.current.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
  }
              };

        const navigatePages = (nextPage) => {
            pendingContentScroll.current = true;
            setPages(nextPage);
        };

        const displayedDocumentStatus = planAffaire
            ? roleDocs.statuses.plan
            : termCondition
                ? roleDocs.statuses.term
                : userAgree
                    ? roleDocs.statuses.agree
                    : DOCUMENT_STATUS.SUCCESS;

        useEffect(() => {
            if (!pendingContentScroll.current) return;
            if ([DOCUMENT_STATUS.IDLE, DOCUMENT_STATUS.LOADING].includes(displayedDocumentStatus)) return;
            pendingContentScroll.current = false;
            scrollToParagraph(divInfoRoll);
        }, [pages, displayedDocumentStatus]);

        // Persist a fresh, valid URL token as the new fallback (replacing any older
        // value) before the first API call goes out, so a first-time visit never
        // fires a request with an empty/invalid token.
        useEffect(() => {
            persistUserAddingRoleTokenIfNeeded(urlToken);
            setTokenStatus(token ? "ready" : "error");
        }, [urlToken, token]);

        // One invitation per URL token: a new token resets everything that
        // belonged to the previous invitation before loading the new one (the
        // previous effect also depended on roleUser, which reloaded the
        // invitation a second time every time the offered role was set).
        useEffect(() => {
            activeTokenRef.current = token;
            appliedSearchRef.current = null;
            setUserInfo({});
            SetRoleUser('Royalty');
            getUserleve(undefined);
            setRoleNamePage({ plan: '', term: '', agree: '', role: '' });
            setPages(BnPlanAffaire);
            setPlanAfCh(false);
            setTernConCh(false);
            setAgreeCh(false);
            setMessageExp(false);
            setActivationErrorCode(null);
            if (tokenStatus !== "ready" || !token) return;
            loadingUserAct(token, '', '', false, false)
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [token, tokenStatus]);

        // "?r=" is honored once per token + search string, after the
        // invitation and its read access are known, and only if readable.
        const accessLoading = roleDocs.accessStatus === DOCUMENT_STATUS.LOADING;
        useEffect(() => {
            if (!checkObjEmpty(userInfo) || accessLoading) return;
            const key = `${token}|${location.search}`;
            if (appliedSearchRef.current === key) return;
            appliedSearchRef.current = key;
            const requested = canonicalRoleId(requestedFromUrl);
            if (requested && readableRoleIds.includes(requested)) chosingRolePage(requested);
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [location.search, token, userInfo, accessLoading, readableRoleIds.join(",")]);

        // A displayed role that turns out not to be readable falls back to
        // the invited role.
        useEffect(() => {
            if (!role || accessLoading || readableRoleIds.length === 0) return;
            if (!readableRoleIds.includes(role)) {
                chosingRolePage(resolveViewedRole({ invitedRole: roleUser, readableRoleIds }));
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [role, accessLoading, readableRoleIds.join(","), roleUser]);

        // let  paragra0 =  !infoSource.loading &&  infoSource.languageAPI.elakayInfoAPI

        let telephone1 = {
            country: 'United States',
            abrCountry: 'US',
            ariaCode: '1',
            National: '(347) 781-3174',
            International: '+1 347 781 3174'
        }
        let userA = {firstname: "Yves", lastname: "Oxilus", password: 'userElakay2018' }

       let address = {
              firstName: 'intel',
              lastName: 'travail',
              shopName: null,
              tel: '+1 347 781 3174',
              Address1: '1091 Hancock st',
              Address2: '',
              city: 'Brooklyn',
              State: 'New York',
              postalCode: '11221',
              country: 'US'
            }

        const loadingUserAct = (token, key, value, save, relaod) => {
            activatorUserAdding(token, key, value, save)
                .then(data => {
                    if (token !== activeTokenRef.current) return;
                    if (data.error) {
                        setActivationErrorCode(data.code || null)
                        setMessageExp(true)
          setTimeout(() => {
                       if (!autheToken) {
                        setMessageWelcome(false);
                        } else {
                     
                      const userInfo = infoSource.userInfo;
                      const activeRole = userInfo?.userActiveRole;

                      // Vérifie que userInfo et userActiveRole ne sont pas vides
                      if (
                        userInfo &&
                        activeRole &&
                        Object.keys(activeRole)?.length > 0 
                      ) {
                        setUserInfo(userInfo);
                        SetRoleUser(activeRole.roleName);
                        getUserleve(computeMaxAuthorizedLevel(activeRole, null));
                        chosingRolePage(activeRole.roleName);
                        setMessageWelcome(true);
                      } else {
                        console.warn("Role non défini ou incomplet.");
                        setMessageWelcome(false);
                      }
                  }
                        }, 3000);  
                    } else {
                      localStorage.setItem("token_userAdding", token);
                        setMessageExp(false)
                        setActivationErrorCode(null)
                        checkAllInfoEnt(data)
                        setUserInfo(data)
                        // mission section 10/11: the single source of truth for
                        // "which role is actually being offered by this
                        // invitation" is now data.assignedRole (built
                        // server-side by activatorUserAdding, already correctly
                        // resolved between the pending proposal and the
                        // account's previous role) -- never
                        // data.userActiveRole.roleName directly, which is the
                        // account's *previous* top-level role and would show a
                        // stale role (e.g. "Provider") whenever one is pending.
                        SetRoleUser(data.assignedRole?.roleName || data.userActiveRole.roleName)
                        getUserleve(computeMaxAuthorizedLevel(data.userActiveRole, data.assignedRole))
                        chosingRolePage(data.assignedRole?.roleName || data.userActiveRole.roleName)
                        relaod &&  setPagesUser(bninfoPersonnel)
                    }
                });
        };
        
        // Shared role -> document keys map (utils/roleDocuments.js). Family uses
        // the real FrTxtLanguage fields planProFamillyElakay/termConditionFamilly/
        // FamillyAgree -- "planAffaireFamily"/"familyAgree" never existed.
        const chosingRolePage =(a)=>{
            const roleId = canonicalRoleId(a)
            const keys = getRoleDocumentKeys(roleId)
            if (!keys) return
            setPages(BnPlanAffaire)
            setRoleNamePage({ ...keys, role: roleId })
        }

        // The role actually offered by this invitation is decided once,
        // server-side, when the invite is created (UpdateUserRoleByAdmin) --
        // never by the invitee here. `roleUser`/the account's real role is
        // never touched by the radios below: they only ever call
        // chosingRolePage(), which swaps roleNamePage.role (which
        // plan/terms/mode d'emploi text is displayed) -- never SetRoleUser,
        // which would re-trigger the [..., roleUser, ...] effect above and
        // refetch/reset the page. userAssUpRoleTrueRandom (the real
        // activation call) still takes no role parameter at all, so no
        // selection made here can ever change what gets saved to
        // userActiveRole/MongoDB.
        const handleUserRoleView = (roleName) => {
            // Defense in depth: only readable roles are ever rendered, but
            // never trust a radio's value alone (e.g. devtools tampering).
            // The backend refuses any other role anyway.
            if (!readableRoleIds.includes(roleName)) return;
            chosingRolePage(roleName);
        }

            const bonPrev = (a, t = true)=>{
              return  t?<button type="button" onClick={()=> navigatePages(a)} className="btn uart-btn uart-btn-prev">
                {infoSource.laguangeElakay('Button', infoSource.languageAPI).previous}
              </button>: <button type="button" onClick={()=> {setMessageExp(true); scrollToParagraph(divInfoRoll)}} className="btn uart-btn uart-btn-prev">
                {infoSource.laguangeElakay('Button', infoSource.languageAPI).previous}
             </button>
            }
           const  bonNext = (a, t = true)=>{
               return t? <button type="button" onClick={()=> navigatePages(a)} className="btn uart-btn uart-btn-next">
                {infoSource.laguangeElakay('Button', infoSource.languageAPI).next}
             </button> : <button type="button" onClick={()=> {setMessageExp(true); scrollToParagraph(divInfoRoll)}} className="btn uart-btn uart-btn-next">
                {infoSource.laguangeElakay('Button', infoSource.languageAPI).next}
             </button>
            }

            const allBon = (p, n, t)=>{
                return  <div className="row justify-content-center uart-actions-wrap">
                <div className="col col-12">
                    <div className="uart-btn-row clearfix ">
                        { p && bonPrev(p, t)}
                        {n && bonNext(n, t)}
                    </div>
                </div></div>
            }
            const checkObjEmpty =(obj)=>{
                if(Object.values(obj ? obj: [])?.length > 0){
                    
                    return true
                }else {
                    // setMessageExp(true)
                    return false
                }
                
                }

                const isNotEmptyObject = (obj) =>
  obj && typeof obj === 'object' && Object.keys(obj)?.length > 0;

        const shouldShowWelcomeMessage = (messageWelcome, userInfo) => {
        return !!(
            messageWelcome === true &&
            isNotEmptyObject(userInfo) &&
            isNotEmptyObject(userInfo.userActiveRole)
        );
};
            // One document of the viewed role, with an explicit state for
            // loading / empty / forbidden / expired / network / server errors
            // (replaces checkProdKeyExit + the single "No data" image).
            const invitationFailureStatus = () => {
                if (!messageExp || checkObjEmpty(userInfo)) return null
                if (activationErrorCode === "TOKEN_EXPIRED") return DOCUMENT_STATUS.EXPIRED
                if (activationErrorCode === "INVALID_TOKEN" || activationErrorCode === "TOKEN_NOT_FOUND") return DOCUMENT_STATUS.FORBIDDEN
                return DOCUMENT_STATUS.SERVER_ERROR
            }
            const pageSteps = (kind)=>{
                return <div className="uart-content-card">
                    <RoleDocumentContent
                        infoSource={infoSource}
                        status={invitationFailureStatus() || roleDocs.statuses[kind]}
                        document={roleDocs.documents[kind]}
                        errorCode={roleDocs.error?.code}
                        onRetry={invitationFailureStatus() ? () => loadingUserAct(token, '', '', false, false) : roleDocs.retry}
                    />
                </div>
            }


         const  planAffairePage =()=>{
                return planAffaire && <div ref={divInfoRoll}>
                    {pageSteps('plan')}
                    {  allBon(undefined, bnTermCondition)}
                    </div> 
            }     


            const  termConditionPage =()=>{
                return termCondition && <div ref={divInfoRoll}>
                       {pageSteps('term')}
                   
                    {  allBon(BnPlanAffaire, bnAddInfoUser, checkObjEmpty(userInfo))}
                    </div> 
            }
            
            const ckeckIfEdit =(k, AO, B )=>{
                if(k == 'userInfo'&& B){
                    if(AO.firstName != 'user' &&  AO.lastName != 'elakay') {
                     return true
                    } else if(AO.firstName != undefined && AO.lastName != undefined){
                        return true
                    }else{
                        return false        
                }
            } else if(k == 'telephone'&& B){
                if(AO?.length == 0){
                    return true
                } else {
                    return false
                }  
            }else if(k == 'address'&& B){
                if(AO?.length == 0){
                    return true
                } else {
                    return false
                }  
            }
        }
        
            const checkObjEmpty1 =(obj)=>{
               let arry = obj && Object.values(obj)
         
                }
                const relaodFonctionToken =()=>{
                        loadingUserAct(token, '', '', false, false)
                         setPages(bnAddInfoUser)
                }


                const resteAllData =(a)=>{

                    checkAllInfoEnt(a)
                    setUserInfo(a)
                    // setPages(bnAddInfoUser)
                  //  setTimeout(() => { setPages(bnAddInfoUser)   }, 1500);

                }
                
                const checkAllInfoEnt = (obj)=>{
                    let emailTel = obj.telephoneSing ? obj.telephoneSing.International.replaceAll(' ', '')+'@elakay.com': undefined
                    const allowed = ['firstname', 'lastname', 'email']
                    const allowedTel = ['country', 'abrCountry', 'ariaCode', 'National', 'International']
                    const allowedAdr = ['firstName', 'lastName', 'tel', 'Address1', 'city', 'State', 'postalCode', 'country'] 
                    let val = obj['firstname'] == 'user'&& obj['lastname'] == 'elakay' && obj['email'] == emailTel
                    let valArr = allowed.every((ar)=>  obj[ar] != '' && obj[ar] != undefined)
                    let valTel = allowedTel.every((ar)=> obj['telephone']?.length > 0 && obj['telephone'][0][ar] !== '' && obj['telephone'][0][ar] !== undefined)
                    let valAdr = allowedAdr.every((ar)=> obj['address']?.length > 0 && obj['address'][0][ar] !== '' && obj['address'][0][ar] !== undefined)
                    setAgreUsIn(!val && valArr && valTel && valAdr)
                }

        const checkInfoUser = (obj, ele, pa, upt, ifu)=>{

            let emailTel = obj.telephoneSing ? obj.telephoneSing.International.replaceAll(' ', '')+'@elakay.com': undefined
    
            let val = obj[ele] == 'user' || obj[ele] == 'elakay' || obj[ele] == emailTel || obj[ele] == undefined || obj[ele] == '' 
        
            let contunue 
           if(pa == 'edit'){
               if( obj && obj[ele] && val){
                contunue = false
               }else{
                contunue = true
               }
            }else if(pa == 'userInfo'){
                let a = obj && obj[ele] && !val && ifu && upt 
             
                a && setPagesUser(bnTelephone)
                contunue = true
            }else if(pa == 'telephone'){
                const firstTelephone = Array.isArray(obj?.[pa]) ? obj[pa][0] : undefined
                let a = obj && checkObjEmpty(firstTelephone) && !val && ifu && upt
                a && setPagesUser(bnAddAdress)
                contunue = true
            }
            else if(pa == 'address'){
                const firstAddress = Array.isArray(obj?.[pa]) ? obj[pa][0] : undefined
                let a = obj && checkObjEmpty(firstAddress) && !val && ifu && upt
                a ? contunue = false : contunue = true
            }
            return  contunue

        }
        

    const  IncompleteProfileAlert = (lang = "en") => {
  const alertData = incompleteProfileAlert[lang] || incompleteProfileAlert["en"];

  return (
    <div className="alert alert-warning uart-incomplete-alert" role="alert">
      <strong><span style={{ fontSize: "30px", lineHeight: "1" }}>↑</span>{alertData.title}:</strong><br />
      {alertData.body}<br />
      👉 <button type="button" onClick={()=> {setPages(bnAddInfoUser); scrollToParagraph(divInfoRoll)}} className="alert-link uart-alert-link">{alertData.link}</button>
    </div>
  );
};
        

            const planAddInfoUser =()=>{
                return checkObjEmpty(userInfo) && addInfoUser &&  <section ref={divInfoRoll} className="uart-sign-card uart-plan-info-card">
                    <header className="uart-sign-card-header">
                        <div className="uart-form-icon-wrapper">
                            <div className="uart-form-icon-circle">
                                <FaUserPlus />
                            </div>
                        </div>
                        <h3 className="uart-sign-card-title">
                            {infoSource.language(infoSource, "label", "AddInfo")}
                        </h3>
                        <p className="uart-sign-card-subtitle">
                            {infoSource.language(infoSource, "text", "textAddinFUs0")}
                        </p>
                        <div className="uart-signup-icon-strip" aria-hidden="true">
                            <span><MdPerson /></span>
                            <span><MdEmail /></span>
                            <span><MdLock /></span>
                        </div>
                    </header>
                    <div className="uart-sign-card-body">
         {         checkObjEmpty(userInfo) &&  <GetEditInfoUser
                     setPagesUser={setPagesUser}
                     setUserInfo={resteAllData} 
                    bnTelephone={bnTelephone}
                    checkObjEmpty={checkObjEmpty}
                    checkInfoUser={checkInfoUser}
                    relaodFonctionToken={relaodFonctionToken}
                    userInfo={userInfo}
                      token={token}
                      infoSource={ infoSource}
                      loadingUserAct={loadingUserAct}
                    />}
              {   checkInfoUser(userInfo, 'firstname', 'userInfo', infoPersonnel, addInfoUser) &&  infoPersonnel && < AddinfoUser
                    setPagesUser={setPagesUser}
                    bnTelephone={bnTelephone}
                    setUserInfo={resteAllData}
                    userInfo={userInfo}
                     infoSource={ infoSource}
                     checkInfoUser={checkInfoUser}
                     token={token}
                    />}

              { checkInfoUser(userInfo, 'firstname', 'telephone', telephone, addInfoUser) && telephone &&  <AddtelephoneUserAssociate 
                     setPagesUser={setPagesUser}
                     bnAddAdress={bnAddAdress}
                     setUserInfo={resteAllData}
                     infoSource={ infoSource}
                     token={token}
                    />}

              {  checkInfoUser(userInfo, 'firstname', 'address', AddAdress, addInfoUser) && AddAdress &&  <AddAddressUserAssociate
                     setPagesUser={setPages}
                     bnTelephone={bnUserAgree}
                     setUserInfo={resteAllData}
                      infoSource={ infoSource}
                      fullName={{firstname: userInfo.firstname, lastname: userInfo.lastname}}
                      phoneUser={userInfo.telephone}
                      token={token}
                    />}
                    </div>
                    <footer className="uart-sign-card-footer">
                    {  allBon(bnTermCondition, bnUserAgree)}
                    </footer>
                    </section> 
            }
            // User.toJSON() strips the whole `ativator` array (mission section
            // 6: "never expireAtUser/createdAt/a role date") -- the real
            // expiration of *this* activation token now comes from
            // data.activation.expiresAt, built server-side in
            // activatorUserAdding from the exact matched ativator[] entry
            // (never ativator[0], which used to be undefined here anyway
            // since ativator itself was never sent to this page at all).
            const activatorDate = userInfo?.activation?.expiresAt || null

             const  CheckBoxButton = ()=>{
                setPlanAfCh(prev => !prev)
             }
             const  CheckBoxButton0 = ()=>{
                setTernConCh(prev => !prev)
             }
             const  CheckBoxButton1 = ()=>{
                setAgreeCh(prev => !prev)
             }


    const clickAgree = () => {
        // Belt-and-suspenders: never submit once the activation link is
        // known to be expired, even if this were ever reached by something
        // other than the (already-disabled) button above.
        if (messageExp) return
        setActivePageAss(true)
        userAssUpRoleTrueRandom(token).then(data => {
            if (data.error) {
            } else {
            }
        })


    }
             const  sendCodeBnt = ()=>{
                // mission section 10: once the activation countdown reaches
                // zero (messageExp), the accept/continue action is disabled
                // and frontend submission is prevented -- the same signal the
                // backend's own TOKEN_EXPIRED response already sets, so this
                // never relies on the frontend timer alone.
                return planAfCh && ternConCh && agreeCh && agreUsIn && !messageExp ?
                <button type="button" onClick={()=> clickAgree()} className="btn uart-btn uart-btn-activate">
                {/* active user */}
                {infoSource.language(infoSource, "Button", "actUser")}
              </button> : <button type="button" className="btn uart-btn uart-btn-activate disabled" disabled>
              {/* active user */}
              {infoSource.language(infoSource, "Button", "actUser")}
              </button>
             }

            
        
            // Confirmations and activation always concern the role this
            // invitation offers (roleUser, from data.assignedRole) -- reading
            // another role's Final Agreement never makes it acceptable.
            const viewingInvitedRole = !role || role === roleUser
            const invitedRoleAgreementNotice = () => (
                <div className="uart-role-agree-notice">
                    <p className="role-doc-notice">
                        <FaInfoCircle aria-hidden="true" />
                        <span>{rd("acceptOnlyInvited", "To accept, open the Final Agreement of {invited}.", { invited: roleLabelOf(roleUser) })}</span>
                    </p>
                    <button type="button" className="btn uart-btn uart-btn-next" onClick={() => { chosingRolePage(roleUser); setPages(bnUserAgree) }}>
                        {roleLabelOf(roleUser)}
                    </button>
                </div>
            )

            const userAgreePage =()=>{
                return userAgree && <section ref={divInfoRoll} className="uart-sign-card uart-agree-card">
                    <div className="uart-agreement-panel">
                    <header className="uart-sign-card-header uart-agreement-header">
                        <div className="uart-form-icon-wrapper">
                            <div className="uart-form-icon-circle">
                                <FaHandshake />
                            </div>
                        </div>
                        <h3 className="uart-sign-card-title">{infoSource.language(infoSource, "label", "FinalAgree")}</h3>
                        <p className="uart-sign-card-subtitle">
                          {__elakayText("t015", "Confirmez les éléments suivants pour activer votre compte.")}
                        </p>
                    </header>
                    <div className="uart-agreement-body">
                    {pageSteps('agree')}
                    {viewingInvitedRole ? <ul className="uart-checkbox-list">
                            <li className={`uart-checkbox-card ${planAfCh ? "is-checked" : ""}`}>
                            <input
                                    onChange={CheckBoxButton}
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={planAfCh}
                                    id="planAffairLu"
                                />
                                <label className="form-check-label" htmlFor="planAffairLu">
                                    <span className="uart-checkbox-label-text">
                                        {/* es ce que vous avez lu le plan d'affaire  */}
                                        {infoSource.language(infoSource, "label", "planAffairLu")}
                                    </span>
                                    </label>
                            </li>
                            <li className={`uart-checkbox-card ${ternConCh ? "is-checked" : ""}`}>
                            <input
                                    onChange={CheckBoxButton0}
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={ternConCh}
                                    id="termConditionAgre"
                                />
                                <label className="form-check-label" htmlFor="termConditionAgre">
                                    <span className="uart-checkbox-label-text">
                                        {/* es ce que vous ete d'acord avec les term et les condition */}
                                        {infoSource.language(infoSource, "label", "termConditionAgre")}
                                    </span>
                                    </label>
                            </li>
                            <li className={`uart-checkbox-card uart-checkbox-status ${agreUsIn ? "is-checked" : "is-pending"}`}>
                            <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={agreUsIn}
                                    id="allInfoOk"
                                    readOnly
                                />
                                <label className="form-check-label" htmlFor="allInfoOk">
                                    <span className="uart-checkbox-label-text">
                                        {/* tous les user information are ok  */}
                                        {infoSource.language(infoSource, "label", "allInfoOk")}
                                    </span>
                                    </label>
                                    {!agreUsIn && IncompleteProfileAlert(code)}
                            </li>
                            <li className={`uart-checkbox-card ${agreeCh ? "is-checked" : ""}`}>
                                <input
                                    onChange={CheckBoxButton1}
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={agreeCh}
                                    id="chButAgree"
                                />
                                <label className="form-check-label" htmlFor="chButAgree">
                                <span className="uart-checkbox-label-text">
                                    {infoSource.language(infoSource, "title", "chButAgree")}
                                     {' '}
                                    {/* avec le deux volet pour continue */}
                                    {infoSource.language(infoSource, "label", "acpContinue")}
                                </span>
                                     </label>
                            </li>
                        </ul> : invitedRoleAgreementNotice()}
                    </div>
                    {viewingInvitedRole && <div className="uart-agreement-activate">
                    {sendCodeBnt()}
                    </div>}
                    </div>
                    <footer className="uart-sign-card-footer">
                    {  allBon(bnAddInfoUser, undefined, checkObjEmpty(userInfo))}
                    </footer>
                    </section>
            }




            const allform =()=>{
               return <div  className="row mt-4 mb-4 justify-content-center">
                <div className="col col-12 col-md-12 col-lg-11 col-xl-11 p-0 uart-page-shell" >
                {planAffairePage()}
                {termConditionPage()}
                {planAddInfoUser()}
                {userAgreePage()}
                 </div>
                 </div>
            
            }



            const activaTorPageForm = () => (
                <div className="contaire">
                    <div className="row justify-content-center " >
                        <Modal
                            size="lg"
                            show={activePageAss}
                            onHide={() => setActivePageAss(false)}
                            dialogClassName="modal-90w"
                            contentClassName="uart-modal-content"
                            aria-labelledby="example-custom-modal-styling-title"
                            centered
                        >
                            <Modal.Header closeButton className="uart-modal-header">
                                <Modal.Title id="example-custom-modal-styling-title">
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>

                            <ActivatorPageAss
                             laguangeElakay={ laguangeElakay}
                             infoSource={infoSource}
                             token={token}
                            />
                            </Modal.Body>
                        </Modal>
                    </div>
                </div>
            )
            // Precise title/message per real cause (mission: never one generic
            // "expired" message regardless of what actually happened) --
            // falls back to the pre-existing "compExp" copy when the cause is
            // unknown (e.g. a network error, no `code` from the backend).
            const expireLinkCopy = () => {
                if (activationErrorCode === "TOKEN_EXPIRED") {
                    return {
                        title: __elakayText("t018", "Ce lien d'activation a expiré"),
                        body: __elakayText("t019", "Veuillez contacter la personne qui vous l'a envoyé pour obtenir un nouveau lien.")
                    }
                }
                if (activationErrorCode === "TOKEN_NOT_FOUND") {
                    return {
                        title: __elakayText("t016", "Ce lien n'est plus valide"),
                        body: __elakayText("t017", "Ce lien d'activation est invalide ou déjà utilisé. Demandez un nouveau lien à votre administrateur.")
                    }
                }
                if (activationErrorCode === "INVALID_TOKEN") {
                    return {
                        title: __elakayText("t016", "Ce lien n'est plus valide"),
                        body: __elakayText("t017", "Ce lien d'activation est invalide ou déjà utilisé. Demandez un nouveau lien à votre administrateur.")
                    }
                }
                return {
                    title: infoSource.language(infoSource, "title", "compExp"),
                    body: null
                }
            }

            const expireLink = () => {
                const copy = expireLinkCopy()
                // Preserves this invitation through the login round-trip
                // (mission 13.2): Signin.js reads ?returnUrl=... and, once
                // authenticated, navigates back here instead of "/" --
                // getSafeReturnUrl() there only ever accepts this exact
                // same-origin relative path.
                const returnPath = buildUserAddingRoleTokenPath(token)
                const signinHref = returnPath ? `/signin?${RETURN_URL_QUERY_PARAM}=${encodeURIComponent(returnPath)}` : "/signin"
                return (
                <div className="contaire">
                    <div className="row justify-content-center ">
                        <Modal
                            size="lg"
                            show={messageExp && !autheToken}
                            onHide={() => setMessageExp(false)}
                            contentClassName="uart-modal-content"
                            aria-labelledby="example-custom-modal-styling-title"
                            centered
                        >
                            <Modal.Header closeButton className="uart-modal-header">
                                <Modal.Title id="example-custom-modal-styling-title" >
                                    <h2>{copy.title}</h2>
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="uart-modal-body">
                           {copy.body && <p>{copy.body}</p>}
                           <Link className="m-2 btn uart-btn uart-btn-link" to={signinHref}>{infoSource.laguangeElakay('Button', infoSource.languageAPI).signin}</Link>

                           <Link className="m-2 btn uart-btn uart-btn-link" to="/">{__elakayText("t013", "elakay")}</Link>
                            </Modal.Body>
                        </Modal>
                    </div>
                </div>
                )
            }

        

            const stepClass = (isCurrent, everPast) => isCurrent ? "active" : everPast ? "done" : "";
            let plsh = stepClass(planAffaire, termCondition || addInfoUser || userAgree);
            let tcsh = stepClass(termCondition, addInfoUser || userAgree);
            let insh = stepClass(addInfoUser, userAgree);
            let Agsh = stepClass(userAgree, false);
            const roleLabelOf = (roleId) => userRolle.find(item => item.name === roleId)?.label || roleId || ''
            const selectedRoleLabel = roleLabelOf(role || roleUser)
            const currentRoleName = canonicalRoleId(userInfo?.userActiveRole?.roleName)
            const stepSeller = ()=>(
           <div className="row justify-content-center mt-3 uart-progress-area">
          <div className="col-12 col-md-11 col-lg-10">
            <div className="uart-progress-wrapper">
                <div className="uart-progress-header">
                <div className="uart-progress-copy">
                <h2 className="uart-progress-title">
                    {/* all to Know about  */}
                    {infoSource.language(infoSource, "label", "allKnowAbout")}{' '}
                    <span>{selectedRoleLabel}</span> </h2>
                    <p className="uart-progress-subtitle">
                      {__elakayText("t014", "Suivez les 4 étapes ci-dessous pour activer votre compte.")}
                    </p>
                    {checkObjEmpty(userInfo) && (
                        <div className="uart-role-meta">
                            {currentRoleName && currentRoleName !== roleUser && (
                                <span>{rd("currentRole", "Current role")}: <strong>{roleLabelOf(currentRoleName)}</strong></span>
                            )}
                            <span>{rd("invitedRole", "Invited role")}: <strong>{roleLabelOf(roleUser)}</strong></span>
                        </div>
                    )}
                    </div>
                 {/* The shared countdown, driven by the server-resolved
                     ativator[] entry's own experyDate. onExpire re-uses the
                     same messageExp flow as the backend's TOKEN_EXPIRED
                     response -- the backend re-checks expiry on every request
                     regardless of this display. */}
                 {checkObjEmpty(userInfo) && activatorDate && (
                    <div className="uart-activation-countdown-wrap">
                        <ActivationCountdown
                            infoSource={infoSource}
                            expiresAt={activatorDate}
                            onExpire={() => setMessageExp(true)}
                            variant="blocks"
                        />
                    </div>
                 )}
                </div>
                    <div className="uart-role-field">
   {  checkObjEmpty(userInfo)  && <>
    <p className="uart-role-field-label" id="uart-role-field-label">{rd("viewRole", "Role to read")}</p>
    <div
        className="uart-role-radio-group"
        role="radiogroup"
        aria-labelledby="uart-role-field-label"
    >
     {userRolle.filter(item => readableRoleIds.includes(item.name)).map((s) => (
        <label
            key={s.name}
            className={`uart-role-radio-option ${role === s.name ? "is-checked" : ""}`}
        >
            <input
                type="radio"
                name="uartRoleView"
                className="form-check-input"
                value={s.name}
                checked={role === s.name}
                onChange={() => handleUserRoleView(s.name)}
            />
            <span className="uart-role-radio-label">{s.label}</span>
        </label>
     ))}
    </div>
    {role && role !== roleUser && (
        <p className="role-doc-notice">
            <FaInfoCircle aria-hidden="true" />
            <span>{rd("viewingNotice", "You are reading the {viewed} documents. Your invitation remains: {invited}.", { viewed: roleLabelOf(role), invited: roleLabelOf(roleUser) })}</span>
        </p>
    )}
    </>}
</div>
              <ol className="uart-progress-bar mt-4">
                <li className={plsh}>
                    <button type="button" onClick={()=> navigatePages(BnPlanAffaire)}>
                    <span className="uart-step-icon"><FaFileContract /></span>
                    {/* Plan D'affaire */}
                    {infoSource.language(infoSource, "label", "planAffai")}
                    </button>
                    </li>
                <li className={tcsh}>
                    <button type="button" onClick={()=> navigatePages(bnTermCondition)}>
                    <span className="uart-step-icon"><FaFileSignature /></span>
                    {/* Term & Condition */}
                    {infoSource.language(infoSource, "label", "termCondi")}
                    </button>
                    </li>
                <li className={insh}>
                    <button type="button" onClick={()=>navigatePages(bnAddInfoUser)}>
                    <span className="uart-step-icon"><FaUserPlus /></span>
                    {/* Add your info */}
                    {infoSource.language(infoSource, "label", "AddInfo")}
                    </button>
                    </li>
                <li className={Agsh}>
                    <button type="button" onClick={()=> navigatePages(bnUserAgree)}>
                    <span className="uart-step-icon"><FaHandshake /></span>
                    {/* Final Agree */}
                    {infoSource.language(infoSource, "label", "FinalAgree")}
                    </button>
                    </li>
              </ol>
            </div>
          </div>
        </div>
            )

    const layoutTitle = infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addUserUserAddingRoleByToken.t003;
    const layoutDescription = elakayAutoText("h_41682905073222", "Node React E-commerce App");

    // No usable token (bad/expired link, or first render before resolution runs):
    // show a controlled, understandable state instead of a blank/stuck page.
    if (tokenStatus === "error") {
        return (
            <Layout
                infoSource={infoSource}
                title={layoutTitle}
                description={layoutDescription}
                className="container-fluid"
                loading={false}
                SliderPunShow={false}
                {...infoSource?.allSettings?.layout}
            >
                <div className="uart-role-page container text-center py-5" style={infoSource.styleNav}>
                    <h3>{__elakayText("t016", "Ce lien n'est plus valide")}</h3>
                    <p>{__elakayText("t017", "Ce lien d'activation est invalide, expiré ou déjà utilisé. Demandez un nouveau lien à votre administrateur.")}</p>
                    <Link className="m-2 btn uart-btn uart-btn-link" to="/">{__elakayText("t013", "elakay")}</Link>
                </div>
            </Layout>
        );
    }

    if (tokenStatus === "resolving") {
        return (
            <Layout
                infoSource={infoSource}
                title={layoutTitle}
                description={layoutDescription}
                className="container-fluid"
                loading={true}
                SliderPunShow={false}
                {...infoSource?.allSettings?.layout}
            >
                <div className="uart-role-page container text-center py-5" style={infoSource.styleNav} />
            </Layout>
        );
    }

    return (
        <Layout
            infoSource ={infoSource}
            title={layoutTitle}
            description={layoutDescription}
            className="container-fluid"
            loading={loading}
            SliderPunShow={false}
            {...infoSource?.allSettings?.layout}
        >
        <div className="uart-role-page" style={infoSource.styleNav}>
            {stepSeller()}
            {expireLink()}
            {allform()}
            {activaTorPageForm()}
{messageWelcome && <WelcomeAlertShow
  roleName={shouldShowWelcomeMessage(messageWelcome, userInfo)? (userInfo.assignedRole?.roleName || userInfo.userActiveRole.roleName): 'Royalty'}
  userName={shouldShowWelcomeMessage(messageWelcome, userInfo)? userInfo.firstname +' ' + userInfo.lastname: "ass"}
  codeLang={code}
  messageWelcome={messageWelcome}
  setMessageWelcome={setMessageWelcome}
/>}
        </div>
         </Layout>
    );
};

export default  UserAddingRoleByToken;
